<template>
  <div>
    <v-dialog
      max-width="500"
      v-model="addTriggerDialog">
      <AddTrigger
        v-if="addTriggerDialog"
        context="button"
        v-on:triggerupdated="triggerUpdated"
        v-on:close="addTriggerDialog = false" />
    </v-dialog>
    <v-btn
      class="mb-2"
      @click="addTriggerDialog = true"
      block
      variant="tonal">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <div
      class="pt-3"
      style="overflow-y: auto">
      <v-card
        style="background: var(--v-cardColor-base); position: unset !important"
        class="pa-4"
        variant="flat"
        v-for="trigger in userEditObj.triggers">
        <div
          class="mb-2"
          style="display: flex">
          <h3>{{ trigger.name }}</h3>
          <v-spacer />
          <v-btn
            size="small"
            variant="tonal"
            @click="removeTrigger(trigger)">
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </div>
        <TriggerVars :vars="trigger.vars" />
      </v-card>
    </div>
  </div>
</template>
<script setup>
import AddTrigger from '../Shared/AddTrigger.vue';
import TriggerVars from '../Shared/TriggerVars.vue';
import { ref } from 'vue';
const props = defineProps(['userEditObj']);
const addTriggerDialog = ref(false);
function triggerUpdated(newTemplateData) {
  props.userEditObj.triggers.push(newTemplateData);
  addTriggerDialog.value = false;
}
function removeTrigger(trigger) {
  const index = props.userEditObj.triggers.indexOf(trigger);
  if (index > -1) {
    props.userEditObj.triggers.splice(index, 1);
  }
}
</script>
